import { useAdminNotesAnalyticsTab } from '@src/rq/admin';
import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  container: {
    width: '100%',
    height: '100%',
  },
  iframe: {
    border: 'none',
    width: '100%',
    height: 4500,
  },
});

interface AnalyticsTabProps {
  userId: string;
}

const AnalyticsTab = ({ userId }: AnalyticsTabProps) => {
  const styles = useStyles();

  const { data: iframeUrl, isLoading } = useAdminNotesAnalyticsTab({
    userId,
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!iframeUrl) {
    return <div>No data</div>;
  }

  return (
    <div className={styles.container}>
      <iframe
        title="Analytics"
        src={iframeUrl}
        allowTransparency
        className={styles.iframe}
      />
    </div>
  );
};

export default AnalyticsTab;
